<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <mat-drawer-container class="flex-auto h-full">

        <!-- Drawer -->
        <mat-drawer #matDrawer class="w-90 dark:bg-gray-900" [autoFocus]="false" [mode]="drawerMode" [opened]="drawerOpened">
            <lib-header [informacionWizard]="informacionWizard"></lib-header>
            <lib-toolbar *ngIf="false"></lib-toolbar>
            <lib-stepps [pasos]="wizardSteps" [currentStep]="currentStep" (goToStep)="goToStep($event, true)"></lib-stepps>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col overflow-hidden">
            <!-- Header -->
            <div
                class="lg:hidden flex flex-0 items-center py-2 pl-4 pr-6 sm:py-4 md:pl-6 md:pr-8 border-b lg:border-b-0 bg-card dark:bg-transparent">
                <!-- Title & Actions -->
                <button mat-icon-button (click)="back()">
                    <mat-icon [svgIcon]="'heroicons_outline:arrow-sm-left'"></mat-icon>
                </button>
                <h2 class="ml-2.5 text-md sm:text-xl font-medium tracking-tight truncate">
                    {{informacionWizard?.titulo}}
                </h2>
            </div>
            <mat-progress-bar class="hidden lg:block flex-0 h-0.5 w-full"
                              [value]="100 * (currentStep + 1) / informacionWizard?.totalPasos"></mat-progress-bar>

            <!-- Main -->
            <div class="flex-auto overflow-y-auto" cdkScrollable>

                <!-- Contenido -->
                <lib-container
                    class="rounded-2xl shadow overflow-hidden bg-card"
                    [informacionWizard]="informacionWizard"
                    [readOnly]="readOnly"
                    [biosphereConfig]="biosphereConfig"
                    [descargaZipByFolio]="descargaZipByFolio"
                    [skipByVersion]="skipByVersion"
                    [current]="currentStep">
                </lib-container>

                <lib-buttons [pasosTotal]="informacionWizard?.totalPasos" [pasos]="wizardSteps" [currentStep]="currentStep"
                             (goToPreviousStep)="goToPreviousStep()" (goToNextStep)="goToNextStep()" (goToSave)="goToSave()"
                             [isLoading]="isLoading"></lib-buttons>
            </div>

            <!-- Progress & Navigation - Mobile -->
            <div class="lg:hidden flex items-center p-4 border-t bg-card">
                <button
                    mat-icon-button
                    (click)="matDrawer.toggle()">
                    <mat-icon [svgIcon]="'heroicons_outline:view-list'"></mat-icon>
                </button>
                <div class="flex items-center justify-center ml-1 lg:ml-2 font-medium leading-5">
                    <span>{{currentStep + 1}}</span>
                    <span class="mx-0.5 text-hint">/</span>
                    <span>{{informacionWizard.totalPasos}}</span>
                </div>
                <mat-progress-bar
                    class="flex-auto ml-6 rounded-full"
                    [value]="100 * (currentStep + 1) / informacionWizard.totalPasos"></mat-progress-bar>
                <button
                    class="ml-0.5"
                    mat-icon-button
                    [disabled]="isLoading === 'go' || disableNext"
                    (click)="goToNextStep()">
                    <mat-icon [svgIcon]="'heroicons_outline:arrow-narrow-right'" *ngIf="isLoading !== 'go'"></mat-icon>
                    <mat-spinner
                        class="ml-1 customIconSize"
                        *ngIf="isLoading === 'go'">
                    </mat-spinner>
                </button>
            </div>
        </mat-drawer-content>

    </mat-drawer-container>

</div>
